function initPage3(vm) {
	vm.indexQuestionMainLA = 0;
	vm.indexQuestionSubLA = 0;
	vm.loadListQuestion6th();
	vm.loadListQuestion7th();
//	vm.loadListQuestion8th();
	vm.ngayDuSinh0 = false;
	vm.ngayDuSinh1 = false;

	vm.listNongDoCon = [ {
		code : '0',
		name : '0'
	}, {
		code : '1-20',
		name : '1-20'
	}, {
		code : '>20',
		name : '>20'
	} ];

	vm.proposal.laList[0].questionnaireList[0].questionSeq = 3;
	vm.proposal.laList[0].questionnaireList[0].subQuestionSeq = 1;
	vm.proposal.laList[0].questionnaireList[1].questionSeq = 4;
	vm.proposal.laList[0].questionnaireList[1].subQuestionSeq = 1;
	vm.proposal.laList[0].questionnaireList[2].questionSeq = 5;
	vm.proposal.laList[0].questionnaireList[2].subQuestionSeq = 1;
	vm.proposal.laList[0].questionnaireList[3].questionSeq = 5;
	vm.proposal.laList[0].questionnaireList[3].subQuestionSeq = 2;
	vm.proposal.laList[0].questionnaireList[4].questionSeq = 5;
	vm.proposal.laList[0].questionnaireList[4].subQuestionSeq = 3;
	vm.proposal.laList[0].questionnaireList[5].questionSeq = 5;
	vm.proposal.laList[0].questionnaireList[5].subQuestionSeq = 4;
	vm.proposal.laList[0].questionnaireList[6].questionSeq = 5;
	vm.proposal.laList[0].questionnaireList[6].subQuestionSeq = 5;
	vm.proposal.laList[0].questionnaireList[7].questionSeq = 5;
	vm.proposal.laList[0].questionnaireList[7].subQuestionSeq = 6;
	vm.proposal.laList[0].questionnaireList[8].questionSeq = 5;
	vm.proposal.laList[0].questionnaireList[8].subQuestionSeq = 7;
	vm.proposal.laList[0].questionnaireList[9].questionSeq = 5;
	vm.proposal.laList[0].questionnaireList[9].subQuestionSeq = 8;

	vm.proposal.laList[0].questionnaireList[10].questionSeq = 5;
	vm.proposal.laList[0].questionnaireList[10].subQuestionSeq = 9;
	vm.proposal.laList[0].questionnaireList[11].questionSeq = 5;
	vm.proposal.laList[0].questionnaireList[11].subQuestionSeq = 10;
	vm.proposal.laList[0].questionnaireList[12].questionSeq = 5;
	vm.proposal.laList[0].questionnaireList[12].subQuestionSeq = 11;
	vm.proposal.laList[0].questionnaireList[13].questionSeq = 5;
	vm.proposal.laList[0].questionnaireList[13].subQuestionSeq = 12;
	vm.proposal.laList[0].questionnaireList[14].questionSeq = 5;
	vm.proposal.laList[0].questionnaireList[14].subQuestionSeq = 13;
	vm.proposal.laList[0].questionnaireList[15].questionSeq = 5;
	vm.proposal.laList[0].questionnaireList[15].subQuestionSeq = 14;
	vm.proposal.laList[0].questionnaireList[16].questionSeq = 5;
	vm.proposal.laList[0].questionnaireList[16].subQuestionSeq = 15;
	vm.proposal.laList[0].questionnaireList[17].questionSeq = 6;
	vm.proposal.laList[0].questionnaireList[17].subQuestionSeq = 1;
	vm.proposal.laList[0].questionnaireList[18].questionSeq = 7;
	vm.proposal.laList[0].questionnaireList[18].subQuestionSeq = 1;
	vm.proposal.laList[0].questionnaireList[19].questionSeq = 8;
	vm.proposal.laList[0].questionnaireList[19].subQuestionSeq = 1;
	
	vm.proposal.laList[0].questionnaireList[20].questionSeq = 9;
	vm.proposal.laList[0].questionnaireList[20].subQuestionSeq = 1;
	vm.proposal.laList[0].questionnaireList[21].questionSeq = 9;
	vm.proposal.laList[0].questionnaireList[21].subQuestionSeq = 2;
	vm.proposal.laList[0].questionnaireList[22].questionSeq = 10;
	vm.proposal.laList[0].questionnaireList[22].subQuestionSeq = 1;
	vm.proposal.laList[0].questionnaireList[23].questionSeq = 11;
	vm.proposal.laList[0].questionnaireList[23].subQuestionSeq = 1;
	vm.proposal.laList[0].questionnaireList[24].questionSeq = 12;
	vm.proposal.laList[0].questionnaireList[24].subQuestionSeq = 1;
	vm.proposal.laList[0].questionnaireList[25].questionSeq = 13;
	vm.proposal.laList[0].questionnaireList[25].subQuestionSeq = 1;
	vm.proposal.laList[0].questionnaireList[26].questionSeq = 13;
	vm.proposal.laList[0].questionnaireList[26].subQuestionSeq = 2;
	vm.proposal.laList[0].questionnaireList[27].questionSeq = 14;
	vm.proposal.laList[0].questionnaireList[27].subQuestionSeq = 1;
	vm.proposal.laList[0].questionnaireList[28].questionSeq = 14;
	vm.proposal.laList[0].questionnaireList[28].subQuestionSeq = 2;
	vm.proposal.laList[0].questionnaireList[29].questionSeq = 14;
	vm.proposal.laList[0].questionnaireList[29].subQuestionSeq = 3;
	vm.proposal.laList[0].questionnaireList[30].questionSeq = 14;
	vm.proposal.laList[0].questionnaireList[30].subQuestionSeq = 4;
	vm.proposal.laList[0].questionnaireList[31].questionSeq = 14;
	vm.proposal.laList[0].questionnaireList[31].subQuestionSeq = 5;
	vm.proposal.laList[0].questionnaireList[32].questionSeq = 15;
	vm.proposal.laList[0].questionnaireList[32].subQuestionSeq = 1;
	vm.proposal.laList[0].questionnaireList[33].questionSeq = 15;
	vm.proposal.laList[0].questionnaireList[33].subQuestionSeq = 2;
	vm.proposal.laList[0].questionnaireList[34].questionSeq = 15;
	vm.proposal.laList[0].questionnaireList[34].subQuestionSeq = 3;
	vm.proposal.laList[0].questionnaireList[35].questionSeq = 11;
	vm.proposal.laList[0].questionnaireList[35].subQuestionSeq = 2;
	vm.proposal.laList[0].questionnaireList[36].questionSeq = 16;
	vm.proposal.laList[0].questionnaireList[36].subQuestionSeq = 1;
	vm.proposal.laList[0].questionnaireList[37].questionSeq = 17;
	vm.proposal.laList[0].questionnaireList[37].subQuestionSeq = 1;

	vm.proposal.laList[1].questionnaireList[0].questionSeq = 3;
	vm.proposal.laList[1].questionnaireList[0].subQuestionSeq = 1;
	vm.proposal.laList[1].questionnaireList[1].questionSeq = 4;
	vm.proposal.laList[1].questionnaireList[1].subQuestionSeq = 1;
	vm.proposal.laList[1].questionnaireList[2].questionSeq = 5;
	vm.proposal.laList[1].questionnaireList[2].subQuestionSeq = 1;
	vm.proposal.laList[1].questionnaireList[3].questionSeq = 5;
	vm.proposal.laList[1].questionnaireList[3].subQuestionSeq = 2;
	vm.proposal.laList[1].questionnaireList[4].questionSeq = 5;
	vm.proposal.laList[1].questionnaireList[4].subQuestionSeq = 3;
	vm.proposal.laList[1].questionnaireList[5].questionSeq = 5;
	vm.proposal.laList[1].questionnaireList[5].subQuestionSeq = 4;
	vm.proposal.laList[1].questionnaireList[6].questionSeq = 5;
	vm.proposal.laList[1].questionnaireList[6].subQuestionSeq = 5;
	vm.proposal.laList[1].questionnaireList[7].questionSeq = 5;
	vm.proposal.laList[1].questionnaireList[7].subQuestionSeq = 6;
	vm.proposal.laList[1].questionnaireList[8].questionSeq = 5;
	vm.proposal.laList[1].questionnaireList[8].subQuestionSeq = 7;
	vm.proposal.laList[1].questionnaireList[9].questionSeq = 5;
	vm.proposal.laList[1].questionnaireList[9].subQuestionSeq = 8;

	vm.proposal.laList[1].questionnaireList[10].questionSeq = 5;
	vm.proposal.laList[1].questionnaireList[10].subQuestionSeq = 9;
	vm.proposal.laList[1].questionnaireList[11].questionSeq = 5;
	vm.proposal.laList[1].questionnaireList[11].subQuestionSeq = 10;
	vm.proposal.laList[1].questionnaireList[12].questionSeq = 5;
	vm.proposal.laList[1].questionnaireList[12].subQuestionSeq = 11;
	vm.proposal.laList[1].questionnaireList[13].questionSeq = 5;
	vm.proposal.laList[1].questionnaireList[13].subQuestionSeq = 12;
	vm.proposal.laList[1].questionnaireList[14].questionSeq = 5;
	vm.proposal.laList[1].questionnaireList[14].subQuestionSeq = 13;
	vm.proposal.laList[1].questionnaireList[15].questionSeq = 5;
	vm.proposal.laList[1].questionnaireList[15].subQuestionSeq = 14;
	vm.proposal.laList[1].questionnaireList[16].questionSeq = 5;
	vm.proposal.laList[1].questionnaireList[16].subQuestionSeq = 15;
	vm.proposal.laList[1].questionnaireList[17].questionSeq = 6;
	vm.proposal.laList[1].questionnaireList[17].subQuestionSeq = 1;
	vm.proposal.laList[1].questionnaireList[18].questionSeq = 7;
	vm.proposal.laList[1].questionnaireList[18].subQuestionSeq = 1;
	vm.proposal.laList[1].questionnaireList[19].questionSeq = 8;
	vm.proposal.laList[1].questionnaireList[19].subQuestionSeq = 1;
	vm.proposal.laList[1].questionnaireList[20].questionSeq = 9;
	vm.proposal.laList[1].questionnaireList[20].subQuestionSeq = 1;
	vm.proposal.laList[1].questionnaireList[21].questionSeq = 9;
	vm.proposal.laList[1].questionnaireList[21].subQuestionSeq = 2;
	vm.proposal.laList[1].questionnaireList[22].questionSeq = 10;
	vm.proposal.laList[1].questionnaireList[22].subQuestionSeq = 1;
	vm.proposal.laList[1].questionnaireList[23].questionSeq = 11;
	vm.proposal.laList[1].questionnaireList[23].subQuestionSeq = 1;
	vm.proposal.laList[1].questionnaireList[24].questionSeq = 12;
	vm.proposal.laList[1].questionnaireList[24].subQuestionSeq = 1;
	vm.proposal.laList[1].questionnaireList[25].questionSeq = 13;
	vm.proposal.laList[1].questionnaireList[25].subQuestionSeq = 1;
	vm.proposal.laList[1].questionnaireList[26].questionSeq = 13;
	vm.proposal.laList[1].questionnaireList[26].subQuestionSeq = 2;
	vm.proposal.laList[1].questionnaireList[27].questionSeq = 14;
	vm.proposal.laList[1].questionnaireList[27].subQuestionSeq = 1;
	vm.proposal.laList[1].questionnaireList[28].questionSeq = 14;
	vm.proposal.laList[1].questionnaireList[28].subQuestionSeq = 2;
	vm.proposal.laList[1].questionnaireList[29].questionSeq = 14;
	vm.proposal.laList[1].questionnaireList[29].subQuestionSeq = 3;
	vm.proposal.laList[1].questionnaireList[30].questionSeq = 14;
	vm.proposal.laList[1].questionnaireList[30].subQuestionSeq = 4;
	vm.proposal.laList[1].questionnaireList[31].questionSeq = 14;
	vm.proposal.laList[1].questionnaireList[31].subQuestionSeq = 5;
	vm.proposal.laList[1].questionnaireList[32].questionSeq = 15;
	vm.proposal.laList[1].questionnaireList[32].subQuestionSeq = 1;
	vm.proposal.laList[1].questionnaireList[33].questionSeq = 15;
	vm.proposal.laList[1].questionnaireList[33].subQuestionSeq = 2;
	vm.proposal.laList[1].questionnaireList[34].questionSeq = 15;
	vm.proposal.laList[1].questionnaireList[34].subQuestionSeq = 3;
	vm.proposal.laList[1].questionnaireList[35].questionSeq = 11;
	vm.proposal.laList[1].questionnaireList[35].subQuestionSeq = 2;
	vm.proposal.laList[1].questionnaireList[36].questionSeq = 16;
	vm.proposal.laList[1].questionnaireList[36].subQuestionSeq = 1;
	vm.proposal.laList[1].questionnaireList[37].questionSeq = 17;
	vm.proposal.laList[1].questionnaireList[37].subQuestionSeq = 1;

	vm.validatePage3 = function() {
		var flag = false;
		flag = vm.validateAllRequired(flag);
		return flag;
	}

	vm.checkWeightBaby = function(type) {
		if (type == 1) {
			if (vm.proposal.laList[0].questionnaireList[30].answer == null
					|| vm.proposal.laList[0].questionnaireList[30].answer == '')
				return;
			var weight = Number(vm.proposal.laList[0].questionnaireList[30].answer);
			if (weight > 200 || weight < 1)
				vm.validateForm.twinKilogram0.$setValidity("maxlength", false);
		} else if (type == 2) {
			if (vm.proposal.laList[1].questionnaireList[30].answer == null
					|| vm.proposal.laList[1].questionnaireList[30].answer == '')
				return;
			var weight = Number(vm.proposal.laList[1].questionnaireList[30].answer);
			if (weight > 200 || weight < 1)
				vm.validateForm.twinKilogram1.$setValidity("maxlength", false);
		} else if (type == 3) {
			if (vm.proposal.laList[0].questionnaireList[27].answer == null
					|| vm.proposal.laList[0].questionnaireList[27].answer == '')
				return;
			var weight = Number(vm.proposal.laList[0].questionnaireList[27].answer);
			if (weight > 200 || weight < 1)
				vm.validateForm.kilogram0.$setValidity("maxlength", false);
		} else if (type == 4) {
			if (vm.proposal.laList[1].questionnaireList[27].answer == null
					|| vm.proposal.laList[1].questionnaireList[27].answer == '')
				return;
			var weight = Number(vm.proposal.laList[1].questionnaireList[27].answer);
			if (weight > 200 || weight < 1)
				vm.validateForm.kilogram1.$setValidity("maxlength", false);
		} else if (type == 5) {
			if (vm.proposal.laList[2].questionnaireList[30].answer == null
					|| vm.proposal.laList[2].questionnaireList[30].answer == '')
				return;
			var weight = Number(vm.proposal.laList[2].questionnaireList[30].answer);
			if (weight > 200 || weight < 1)
				vm.validateForm.twinKilogram0.$setValidity("maxlength", false);
		} else if (type == 6) {
			if (vm.proposal.laList[3].questionnaireList[30].answer == null
					|| vm.proposal.laList[3].questionnaireList[30].answer == '')
				return;
			var weight = Number(vm.proposal.laList[3].questionnaireList[30].answer);
			if (weight > 200 || weight < 1)
				vm.validateForm.twinKilogram1.$setValidity("maxlength", false);
		} else if (type == 7) {
			if (vm.proposal.laList[2].questionnaireList[27].answer == null
					|| vm.proposal.laList[2].questionnaireList[27].answer == '')
				return;
			var weight = Number(vm.proposal.laList[2].questionnaireList[27].answer);
			if (weight > 200 || weight < 1)
				vm.validateForm.kilogram0.$setValidity("maxlength", false);
		} else if (type == 8) {
			if (vm.proposal.laList[3].questionnaireList[27].answer == null
					|| vm.proposal.laList[3].questionnaireList[27].answer == '')
				return;
			var weight = Number(vm.proposal.laList[3].questionnaireList[27].answer);
			if (weight > 200 || weight < 1)
				vm.validateForm.kilogram1.$setValidity("maxlength", false);
		}

	}
}